<template lang="pug">
  div#topOfThePage
    doc-markdown(source=`
    ## Button \`sw-button\`
    `)
    doc-preview(vue=`
    sw-button(href='#') Button Link
    sw-button(@click="warnMessage") Button Action
    sw-button(scrollTo="events") Button Scroll

    sw-button.btn.btn-blue.btn-xs(href='#') Button Styled XS
    sw-button.btn.btn-blue.btn-sm(href='#') Button Styled SM
    sw-button.btn.btn-blue(href='#') Button Styled Blue
    sw-button.btn.btn-white.m-4(href='#') Button Styled White

    sw-button.btn.btn-blue(href='#' :loading="true") Button Loading
    sw-button.btn.btn-blue(@click="warnMessage" :disabled="true").m-4 Button Disabled
    `)
      div
        sw-button(href='#').m-4 Button Link
        sw-button(@click="warnMessage").m-4 Button Action
        sw-button(scrollTo="events").m-4 Button Scroll
      div
        sw-button.btn.btn-blue.btn-xs.m-4(href='#') Button Styled XS
        sw-button.btn.btn-blue.btn-sm.m-4(href='#') Button Styled SM
        sw-button.btn.btn-blue.m-4(href='#') Button Styled Blue
        sw-button.btn.btn-white.m-4(href='#') Button Styled White
      div
        sw-button.btn.btn-blue(href='#' :loading="true").m-4 Button Loading
        sw-button.btn.btn-blue(@click="warnMessage" :disabled="true").m-4 Button Disabled

    doc-markdown(source=`
    ### Properties
    Note that by default, \`SwButton\` will be rendered as a regular \`<a>\` link.
    If the prop \`scroll-to\` is passed, or if \`turbolink="true"\`, the whole component will instead be a  \`<button>\`.
  | Props            | Description                                                                                | Type    | Default |
  |------------------|--------------------------------------------------------------------------------------------|:-------:|:-------:|
  | \`href\`         | On click, redirect to the specified URL.                                                   |  String |    -    |
  | \`disabled\`     | Makes the button disabled (unclickable) & some basic disabled css classes will be applied. | Boolean |  false  |
  | \`scroll-to\`    | On click, triggers a scroll to the passed \`id\` element on the page.                      |  String |    -    |
  | \`scroll-offset\`| In combination with \`scrollTo\`, allows to specify a given offset in pixel to the scroll. |  Number |    0    |
  | \`target\`       | In combination with \`href\`, allows to redirect to another window target.                 |  String | '_self' |
  | \`turbolink\`    | In combination with \`href\`, makes the link a Turbolinks-enabled one.                     | Boolean |  false  |
  | \`loading\`      | Makes the button display a loading animation & become disabled.                            | Boolean |  false  |
    `)

    doc-markdown(source=`
    ### Slots
  | Slot name      | Description           |
  |----------------|-----------------------|
  | *default*      | The text in the buton |
    `)

    doc-markdown(id="events" source=`
    ### Events
  | Event name | Description            | Parameters | Usage      |
  |------------|------------------------|:----------:|------------|
  | click      | Triggered when clicked |      -     | \`@click\` |
    `)

    doc-markdown(source=`
    ### Styles
  | Class                         | Modified attributes | Description                                                                                                   |
  |-------------------------------|---------------------|---------------------------------------------------------------------------------------------------------------|
  | \`.btn\`                      | Base class          | The base class used for all kinds of buttons (positioning, typography, cursor, etc). By default, size is MD.  |
  | \`.btn-xs\`                   | Size                | XS size                                                                                                       |
  | \`.btn-sm\`                   | Size                | SM size                                                                                                       |
  | \`.btn-blue\`                 | Color               | Blue color                                                                                                    |
  | \`.btn-white\`                | Color               | White color                                                                                                   |
  | \`.btn-rounded-left\`         | Border-radius       | Rounded on the left                                                                                           |
  | \`.btn-rounded-right\`        | Border-radius       | Rounded on the right                                                                                          |
  | \`.btn-inline-form\`          | Border-radius       | Rounded, rounded on the right only as from \`sm\`                                                             |
  | \`.btn-inline-form--lg-wrap\` | Border-radius       | Rounded as from \`lg\`, rounded on the rght only as from \`xl\`                                               |
    `)
</template>

<script>
  export default {
    methods: {
      warnMessage () {
        window.alert('Placeholder message');
      },
    },
  };
</script>
